(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[518],{

/***/ 78791:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse",
      function () {
        return __webpack_require__(33751);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var DensityIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, dimension = _param.dimension, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "color",
        "dimension"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: dimension || 18,
        height: dimension || 14,
        viewBox: "0 0 18 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2.08762 0.485352C1.45131 0.485352 0.935547 1.00111 0.935547 1.63742C0.935547 2.27359 1.45131 2.78949 2.08762 2.78949H15.9116C16.5479 2.78949 17.0637 2.27373 17.0637 1.63742C17.0637 1.00111 16.5479 0.485352 15.9116 0.485352H2.08762ZM2.08762 5.86135C1.45131 5.86135 0.935547 6.37711 0.935547 7.01342C0.935547 7.64959 1.45131 8.16549 2.08762 8.16549H15.9116C16.5479 8.16549 17.0637 7.64973 17.0637 7.01342C17.0637 6.37711 16.5479 5.86135 15.9116 5.86135H2.08762ZM2.08762 11.2374C1.45131 11.2374 0.935547 11.7531 0.935547 12.3894C0.935547 13.0256 1.45131 13.5415 2.08762 13.5415H15.9116C16.5479 13.5415 17.0637 13.0257 17.0637 12.3894C17.0637 11.7531 16.5479 11.2374 15.9116 11.2374H2.08762Z",
            fill: color || "#242424"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DensityIcon);


/***/ }),

/***/ 99020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99226);
/* harmony import */ var _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8573);
/* harmony import */ var _helper_gigStates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50481);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24849);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97734);






var GigStateTag = function(param) {
    var gigStateValue = param.gigStateValue, bidValue = param.bidValue;
    var ref = (0,_helper_gigStates__WEBPACK_IMPORTED_MODULE_2__/* .getStateData */ .O)(gigStateValue), color = ref.color, text = ref.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        sx: {
            padding: 1,
            borderRadius: "0.5rem",
            backgroundColor: color,
            width: "fit-content"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            variant: "small5",
            sx: {
                color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.brand1[50] */ .r.brand1[50]
            },
            children: "".concat(text).concat(gigStateValue === _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].OPEN_BID */ .Z.OPEN_BID && bidValue ? ": $".concat(bidValue) : "")
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GigStateTag);


/***/ }),

/***/ 89243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99226);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24849);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97734);





var NoDataUI = function(param) {
    var Icon = param.Icon, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 50 : _iconSize, displayMessage = param.displayMessage, sx = param.sx;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            minHeight: "400px",
            flexDirection: "column",
            gap: 2,
            boxSizing: "border-box"
        }, sx),
        children: [
            Icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                sx: {
                    color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteBg.WBG4 */ .r.whiteBg.WBG4,
                    fontSize: iconSize
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "title4",
                sx: {
                    color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteBg.WBG4 */ .r.whiteBg.WBG4
                },
                children: displayMessage
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoDataUI);


/***/ }),

/***/ 23752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ browse_ChefProfileCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./assets/Icons/ProfileIcon.tsx
var ProfileIcon = __webpack_require__(42198);
// EXTERNAL MODULE: ./mui-customs/Theme.ts
var Theme = __webpack_require__(24849);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(40570);
// EXTERNAL MODULE: ./components/LikeAndUnLikeChef.tsx
var LikeAndUnLikeChef = __webpack_require__(68602);
// EXTERNAL MODULE: ./components/Typography.tsx
var Typography = __webpack_require__(97734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography_Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./components/browse/HourlyRateDisplay.tsx



var HourlyRateDisplay = function(param) {
    var value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            p: "8px 6px",
            background: Theme/* theme.brand2.50 */.r.brand2[50],
            borderRadius: "6px",
            width: "fit-content",
            height: "fit-content"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
            sx: {
                fontSize: "12px",
                lineHeight: "16px",
                fontWeight: "600",
                fontFamily: "Poppins",
                color: Theme/* theme.brand2.850 */.r.brand2[850]
            },
            children: [
                "$",
                value,
                "/Hour"
            ]
        })
    });
};
/* harmony default export */ var browse_HourlyRateDisplay = (HourlyRateDisplay);

;// CONCATENATED MODULE: ./components/browse/ProfileTag.tsx



var ProfileTag = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            p: "4px 8px",
            background: Theme/* theme.whiteBg.WBG3 */.r.whiteBg.WBG3,
            borderRadius: "6px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            sx: {
                fontSize: "12px",
                lineHeight: "16px",
                fontWeight: "400",
                fontFamily: "Poppins",
                color: Theme/* theme.grey2.300 */.r.grey2[300]
            },
            children: text
        })
    });
};
/* harmony default export */ var browse_ProfileTag = (ProfileTag);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Grade.js
var Grade = __webpack_require__(76403);
;// CONCATENATED MODULE: ./components/browse/RatingDisplay.tsx





var RatingDisplay = function(param) {
    var value = param.value, sx = param.sx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_object_spread/* default */.Z)({
            background: Theme/* theme.brand1.500 */.r.brand1[500],
            p: " 6px 8px",
            borderRadius: "5px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            width: "fit-content"
        }, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grade/* default */.Z, {
                sx: {
                    color: Theme/* theme.whiteBg.WBG1 */.r.whiteBg.WBG1,
                    height: "18px",
                    width: "18px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                sx: {
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    color: Theme/* theme.whiteBg.WBG1 */.r.whiteBg.WBG1
                },
                children: value ? value % 1 !== 0 ? value.toFixed(2) : value : 0
            })
        ]
    });
};
/* harmony default export */ var browse_RatingDisplay = (RatingDisplay);

;// CONCATENATED MODULE: ./components/browse/ChefProfileCard.tsx












var ChefProfileCard = function(param) {
    var chef = param.chef;
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            py: 3,
            boxSizing: "border-box",
            width: "100%",
            gap: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            cursor: "pointer"
        },
        onClick: function() {
            router.push("/profile-public/".concat(chef.uid));
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    width: "100%",
                    maxHeight: "300px",
                    borderRadius: "6px",
                    aspectRatio: "327 / 222",
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: Theme/* theme.whiteBg.WBG3 */.r.whiteBg.WBG3,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: chef.profileImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: chef.profileImage,
                    alt: "".concat(chef.firstName, " ").concat(chef.lastName, " profile picture"),
                    layout: "fill",
                    objectFit: "cover",
                    priority: false,
                    loading: "lazy",
                    sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileIcon/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "title6",
                                sx: {
                                    color: Theme/* theme.black.800 */.r.black[800]
                                },
                                children: "".concat(chef.firstName, " ").concat(chef.lastName && chef.lastName[0], ".")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(browse_RatingDisplay, {
                                value: chef.rating
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    // gap: 1,
                                    flex: 1
                                },
                                children: [
                                    chef.bio && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            position: "relative",
                                            pr: 3,
                                            height: "21px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                position: "absolute",
                                                top: 0,
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body3",
                                                sx: {
                                                    color: Theme/* theme.grey2.400 */.r.grey2[400],
                                                    textOverflow: "ellipsis",
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap"
                                                },
                                                children: chef.bio
                                            })
                                        })
                                    }),
                                    ((ref = chef.address) === null || ref === void 0 ? void 0 : ref.locality) && ((ref1 = chef.address) === null || ref1 === void 0 ? void 0 : ref1.state) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            position: "relative",
                                            pr: 3,
                                            height: "21px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                position: "absolute",
                                                top: 0,
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body3",
                                                sx: {
                                                    textOverflow: "ellipsis",
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    color: Theme/* theme.blue.400 */.r.blue[400]
                                                },
                                                children: "".concat((ref2 = chef.address) === null || ref2 === void 0 ? void 0 : ref2.locality, ", ").concat((ref3 = chef.address) === null || ref3 === void 0 ? void 0 : ref3.state)
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: chef.hourlyRate && /*#__PURE__*/ (0,jsx_runtime.jsx)(browse_HourlyRateDisplay, {
                                    value: chef.hourlyRate
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "flex-start",
                    gap: 1,
                    flexWrap: "wrap"
                },
                children: chef.foodPreferences && chef.foodPreferences.map(function(tag, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(browse_ProfileTag, {
                        text: tag
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "end",
                    flex: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        width: "100%",
                        gap: 2,
                        alignItems: "center"
                    },
                    children: [
                        chef.uid && /*#__PURE__*/ (0,jsx_runtime.jsx)(LikeAndUnLikeChef/* default */.Z, {
                            chefUid: chef.uid
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: function() {
                                router.push("/profile-public/".concat(chef.uid));
                            },
                            sx: {
                                flexGrow: 1
                            },
                            children: "View Profile"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var browse_ChefProfileCard = (ChefProfileCard);


/***/ }),

/***/ 18621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yw": function() { return /* binding */ getGigStartDate; },
/* harmony export */   "fc": function() { return /* binding */ convertDateFormat; },
/* harmony export */   "q1": function() { return /* binding */ getGigEndDate; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70178);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29387);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2__);



dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2___default()));
var convertDateFormat = function(date) {
    var addTime = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (addTime) {
        return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).utc().format("MM/DD/YYYY, hh:mm A");
    }
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).utc().format("MM/DD/YYYY");
};
var getGigStartDate = function(gig) {
    var ref;
    var startDate;
    if (gig === null || gig === void 0 ? void 0 : (ref = gig.multiDate) === null || ref === void 0 ? void 0 : ref.startDate) {
        var ref1;
        startDate = gig === null || gig === void 0 ? void 0 : (ref1 = gig.multiDate) === null || ref1 === void 0 ? void 0 : ref1.startDate;
    } else {
        startDate = gig === null || gig === void 0 ? void 0 : gig.date;
    }
    return startDate;
};
var getGigEndDate = function(gig) {
    var ref;
    var endDate;
    if (gig === null || gig === void 0 ? void 0 : (ref = gig.multiDate) === null || ref === void 0 ? void 0 : ref.endDate) {
        var ref1;
        endDate = gig === null || gig === void 0 ? void 0 : (ref1 = gig.multiDate) === null || ref1 === void 0 ? void 0 : ref1.endDate;
    } else {
        endDate = gig === null || gig === void 0 ? void 0 : gig.date;
    }
    return endDate;
};



/***/ }),

/***/ 50481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ getStateData; }
/* harmony export */ });
/* harmony import */ var _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8573);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24849);


function getStateData(state, newText) {
    var color;
    var text;
    switch(state){
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DRAFT */ .Z.DRAFT:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.grey2[500] */ .r.grey2[500];
            text = newText || "Draft";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].OPEN_BID */ .Z.OPEN_BID:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.purple[300] */ .r.purple[300];
            text = newText || "Open Bid";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].NEW_GIG */ .Z.NEW_GIG:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.brand2[500] */ .r.brand2[500];
            text = newText || "New Gig";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ACCEPTED_BOOKED */ .Z.ACCEPTED_BOOKED:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.brand1[500] */ .r.brand1[500];
            text = newText || "Accepted Booked";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DEPOSIT_PAID */ .Z.DEPOSIT_PAID:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.brand1[500] */ .r.brand1[500];
            text = newText || "Accepted Booked";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].INVOICE_CHANGE */ .Z.INVOICE_CHANGE:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.yellow[500] */ .r.yellow[500];
            text = newText || "Invoice Change";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FINISHED_AND_PAID */ .Z.FINISHED_AND_PAID:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.brand1[700] */ .r.brand1[700];
            text = newText || "Finished & Paid";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CANCELED_GIG */ .Z.CANCELED_GIG:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.red[300] */ .r.red[300];
            text = newText || "Canceled Gig";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CANCELED_BID */ .Z.CANCELED_BID:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.red[300] */ .r.red[300];
            text = newText || "Canceled Bid";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DECLINED_BID */ .Z.DECLINED_BID:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.brand2[750] */ .r.brand2[750];
            text = newText || "Declined Bid";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].PENDING */ .Z.PENDING:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.purple[200] */ .r.purple[200];
            text = newText || "Pending";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].LIKED */ .Z.LIKED:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.grey2[500] */ .r.grey2[500];
            text = newText || "Liked";
            break;
        default:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.grey2[500] */ .r.grey2[500];
            text = newText || "None";
            break;
    }
    return {
        color: color,
        text: text
    };
}



/***/ }),

/***/ 33751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ browse; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Person.js
var Person = __webpack_require__(15398);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./mui-customs/Theme.ts
var Theme = __webpack_require__(24849);
// EXTERNAL MODULE: ./components/NoDataUI.tsx
var NoDataUI = __webpack_require__(89243);
// EXTERNAL MODULE: ./components/browse/ChefProfileCard.tsx + 3 modules
var ChefProfileCard = __webpack_require__(23752);
;// CONCATENATED MODULE: ./components/browse/BrowseChefsTab.tsx






var BrowseChefsTab = function(param) {
    var chefs = param.chefs, isLoading = param.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            backgroundColor: Theme/* theme.whiteBg.WBG1 */.r.whiteBg.WBG1,
            p: 3
        },
        children: chefs.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            container: true,
            spacing: 3,
            children: chefs.map(function(chef, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    md: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChefProfileCard/* default */.Z, {
                        chef: chef
                    })
                }, index);
            })
        }) : !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoDataUI/* default */.Z, {
            Icon: Person/* default */.Z,
            displayMessage: "No chef available "
        })
    });
};
/* harmony default export */ var browse_BrowseChefsTab = (BrowseChefsTab);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/FoodBankOutlined.js
var FoodBankOutlined = __webpack_require__(47433);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/GigCard.tsx
var GigCard = __webpack_require__(59012);
// EXTERNAL MODULE: ./components/Typography.tsx
var Typography = __webpack_require__(97734);
;// CONCATENATED MODULE: ./components/browse/BrowseGigsTab.tsx









var BrowseGigsTab = function(param) {
    var gigs = param.gigs, isLoading = param.isLoading;
    var router = (0,next_router.useRouter)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.user.user;
    }), userUid = ref.uid, userType = ref.userType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            backgroundColor: Theme/* theme.whiteBg.WBG1 */.r.whiteBg.WBG1
        },
        children: gigs.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "title4",
                    sx: {
                        p: 3
                    },
                    children: "Gigs you might like"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    children: gigs.map(function(gig, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GigCard/* default */.Z, {
                                gigStatusDisplay: true,
                                gig: gig
                            })
                        }, index);
                    })
                })
            ]
        }) : !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoDataUI/* default */.Z, {
            Icon: FoodBankOutlined/* default */.Z,
            displayMessage: "No gig available "
        })
    });
};
/* harmony default export */ var browse_BrowseGigsTab = (BrowseGigsTab);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Favorite.js
var Favorite = __webpack_require__(36111);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/FavoriteBorder.js
var FavoriteBorder = __webpack_require__(91811);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 2 modules
var MenuItem = __webpack_require__(30431);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 2 modules
var Stack = __webpack_require__(31536);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 4 modules
var Select = __webpack_require__(18360);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./assets/Browse/ChefIcon.tsx




var ChefIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, dimension = _param.dimension, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "dimension"
    ]);
    return (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: dimension || 18,
        height: dimension || 16,
        viewBox: "0 0 18 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.01448 0.525391C7.12568 0.525391 5.56842 1.90525 5.25231 3.70539C4.97949 3.64272 4.69904 3.59732 4.40641 3.59732C2.29005 3.59732 0.566406 5.3211 0.566406 7.43732C0.566406 9.4224 2.0877 11.0459 4.02241 11.2413V15.1173C4.02254 15.3295 4.19437 15.5013 4.40651 15.5013H13.6225C13.8347 15.5013 14.0065 15.3295 14.0066 15.1173V11.2413C15.9412 11.0458 17.4626 9.42243 17.4626 7.43732C17.4626 5.3211 15.739 3.59732 13.6226 3.59732C13.33 3.59732 13.0495 3.64272 12.7767 3.70539C12.4608 1.90525 10.9035 0.525391 9.01455 0.525391H9.01448ZM9.01448 1.29332C10.6614 1.29332 11.9907 2.57825 12.0745 4.20333C12.0804 4.32547 12.144 4.43743 12.2459 4.50493C12.3478 4.57244 12.4757 4.58743 12.5905 4.54538C12.916 4.4286 13.2588 4.36538 13.6224 4.36538C15.3236 4.36538 16.6945 5.73612 16.6945 7.43731C16.6945 9.13847 15.3236 10.5094 13.6224 10.5094C13.4104 10.5094 13.2385 10.6814 13.2385 10.8934V14.7334H4.79048V13.9654H12.0865C12.1892 13.9668 12.2883 13.927 12.3614 13.8548C12.4347 13.7826 12.4759 13.6842 12.4759 13.5813C12.4759 13.4786 12.4347 13.38 12.3614 13.3078C12.2883 13.2358 12.1892 13.1959 12.0865 13.1973H4.79048V10.8934C4.79048 10.6814 4.61851 10.5094 4.40651 10.5094C2.70536 10.5094 1.33444 9.13852 1.33444 7.43733C1.33444 5.73618 2.70532 4.3654 4.40651 4.3654C4.77011 4.3654 5.11297 4.42861 5.43844 4.5454C5.55322 4.58745 5.68112 4.57245 5.78305 4.50495C5.88498 4.43745 5.94858 4.32549 5.95448 4.20334C6.03832 2.57827 7.36756 1.29334 9.01448 1.29334V1.29332Z",
            fill: color || "#8492A6"
        })
    }));
};
/* harmony default export */ var Browse_ChefIcon = (ChefIcon);

;// CONCATENATED MODULE: ./assets/Browse/GigIcon.tsx




var GigIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, dimension = _param.dimension, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "dimension"
    ]);
    return (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: dimension || 18,
        height: dimension || 16,
        viewBox: "0 0 18 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2.39961 15.1998H15.5996C16.0771 15.1998 16.5348 15.0102 16.8725 14.6727C17.21 14.335 17.3996 13.8773 17.3996 13.3998V0.799805H0.599609V13.3998C0.599609 13.8773 0.789251 14.335 1.12675 14.6727C1.46439 15.0102 1.92215 15.1998 2.39961 15.1998ZM15.5996 13.9998H2.39961C2.2405 13.9998 2.08782 13.9366 1.97532 13.8241C1.86283 13.7116 1.79961 13.5589 1.79961 13.3998V6.69181C1.99207 6.76158 2.19496 6.79815 2.39961 6.79975H5.99961V9.19975H7.19961V10.9998C7.19961 11.6429 7.54274 12.2371 8.09961 12.5586C8.65648 12.8801 9.34274 12.8801 9.89961 12.5586C10.4565 12.2371 10.7996 11.6429 10.7996 10.9998V9.19975H11.9996V6.79975H15.5996C15.8043 6.79814 16.0072 6.76158 16.1996 6.69181V13.3998C16.1996 13.5589 16.1364 13.7116 16.0239 13.8241C15.9114 13.9366 15.7587 13.9998 15.5996 13.9998ZM8.39961 9.19981H9.59961V10.9998C9.59961 11.2142 9.48524 11.4123 9.29961 11.5194C9.11399 11.6266 8.88524 11.6266 8.69961 11.5194C8.51399 11.4123 8.39961 11.2142 8.39961 10.9998V9.19981ZM7.19961 7.9998V6.79981H10.7996V7.9998H7.19961ZM16.1996 1.9998V4.9998C16.1996 5.15891 16.1364 5.31159 16.0239 5.42409C15.9114 5.53659 15.7587 5.5998 15.5996 5.5998H10.7996V1.9998H16.1996ZM9.59961 1.9998V5.5998H8.39961V1.9998H9.59961ZM1.79961 1.9998H7.19961V5.5998H2.39961C2.2405 5.5998 2.08782 5.53659 1.97532 5.42409C1.86283 5.31159 1.79961 5.15891 1.79961 4.9998V1.9998Z",
            fill: color || "#B3BCC8"
        })
    }));
};
/* harmony default export */ var Browse_GigIcon = (GigIcon);

// EXTERNAL MODULE: ./assets/Icons/DensityIcon.tsx
var DensityIcon = __webpack_require__(44673);
// EXTERNAL MODULE: ./constants/BrowseType.ts
var BrowseType = __webpack_require__(30694);
// EXTERNAL MODULE: ./redux/createBrowsePageSlice.ts
var createBrowsePageSlice = __webpack_require__(39954);
// EXTERNAL MODULE: ./components/browse/MenuDrawer.tsx + 1 modules
var MenuDrawer = __webpack_require__(79581);
;// CONCATENATED MODULE: ./components/browse/TopBar.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 30px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var StyledMenuItem = (0,emotion_styled_browser_esm/* default */.Z)(MenuItem/* default */.Z)(_templateObject());
var TopBar = function(param) {
    var browseType = param.browseType, setIsDisplayingFavourites = param.setIsDisplayingFavourites;
    var ref = (0,react.useState)(false), displayMenuDrawer = ref[0], setDisplayMenuDrawer = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var userUid = (0,es/* useSelector */.v9)(function(state) {
        return state.user.user.uid;
    });
    var activeTab = (0,es/* useSelector */.v9)(function(state) {
        return state.browsePage.activeTab;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        sx: {
            p: 3,
            position: {
                xs: "fixed",
                md: "static"
            },
            top: 0,
            width: "100%",
            background: Theme/* theme.whiteBg.WBG1 */.r.whiteBg.WBG1,
            zIndex: "99"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                spacing: 2,
                direction: "row",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                    sx: {
                        height: "32px",
                        width: "60px",
                        backgroundColor: Theme/* theme.whiteBg.WBG3 */.r.whiteBg.WBG3,
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: "none"
                        },
                        "& .MuiSelect-select": {
                            padding: 1,
                            pt: "15px"
                        }
                    },
                    value: browseType !== null && browseType !== void 0 ? browseType : BrowseType/* default.Gig */.Z.Gig,
                    onChange: function(e) {
                        if (e.target.value === BrowseType/* default.Chef */.Z.Chef) {
                            dispatch((0,createBrowsePageSlice/* setActiveTab */.r7)(BrowseType/* default.Chef */.Z.Chef));
                        } else {
                            dispatch((0,createBrowsePageSlice/* setActiveTab */.r7)(BrowseType/* default.Gig */.Z.Gig));
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenuItem, {
                            value: BrowseType/* default.Chef */.Z.Chef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Browse_ChefIcon, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenuItem, {
                            value: BrowseType/* default.Gig */.Z.Gig,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Browse_GigIcon, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 2,
                direction: "row",
                alignItems: "center",
                children: [
                    userUid && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        sx: {
                            backgroundColor: "".concat(Theme/* theme.whiteBg.WBG4 */.r.whiteBg.WBG4, " !important"),
                            height: "34px",
                            width: "34px"
                        },
                        onChange: function() {
                            setIsDisplayingFavourites(function(isDisplayingFavourites) {
                                return !isDisplayingFavourites;
                            });
                        },
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteBorder/* default */.Z, {
                            sx: {
                                color: Theme/* theme.grey2.500 */.r.grey2[500],
                                fontSize: "22px"
                            }
                        }),
                        checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Favorite/* default */.Z, {
                            sx: {
                                color: Theme/* theme.brand2.500 */.r.brand2[500],
                                fontSize: "22px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        sx: {
                            background: "".concat(Theme/* theme.whiteBg.WBG3 */.r.whiteBg.WBG3, " !important"),
                            height: "34px",
                            width: "34px"
                        },
                        onClick: function() {
                            setDisplayMenuDrawer(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DensityIcon/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDrawer/* default */.Z, {
                        openState: displayMenuDrawer,
                        handleClose: function() {
                            setDisplayMenuDrawer(false);
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var browse_TopBar = (TopBar);

// EXTERNAL MODULE: ./components/innerLayout/InnerLayout.tsx + 14 modules
var InnerLayout = __webpack_require__(66570);
// EXTERNAL MODULE: ./constants/General.ts
var General = __webpack_require__(63086);
// EXTERNAL MODULE: ./constants/tabs.ts
var tabs = __webpack_require__(28141);
// EXTERNAL MODULE: ./constants/UserType.ts
var UserType = __webpack_require__(22898);
// EXTERNAL MODULE: ./firebase/gig.ts + 1 modules
var gig = __webpack_require__(30622);
// EXTERNAL MODULE: ./firebase/user.ts + 3 modules
var user = __webpack_require__(32012);
// EXTERNAL MODULE: ./redux/createTabSlice.tsx
var createTabSlice = __webpack_require__(89515);
;// CONCATENATED MODULE: ./pages/browse.tsx





















var Browse = function(param) {
    var initialGigsData = param.initialGigsData, initialChefsData = param.initialChefsData, lastUpdated = param.lastUpdated;
    var activeBrowseTab = (0,es/* useSelector */.v9)(function(state) {
        return state.browsePage.activeTab;
    });
    var userUid = (0,es/* useSelector */.v9)(function(state) {
        return state.user.user.uid;
    });
    var userType = (0,es/* useSelector */.v9)(function(state) {
        return state.user.user.userType;
    });
    var ref = (0,react.useState)(false), isFilterPageOpen = ref[0], setIsFilterPageOpen = ref[1];
    var ref1 = (0,react.useState)(false), hasMoreData = ref1[0], setHasMoreData = ref1[1];
    var ref2 = (0,react.useState)(initialGigsData), gigsData = ref2[0], setGigsData = ref2[1];
    var ref3 = (0,react.useState)(initialChefsData), chefData = ref3[0], setChefData = ref3[1];
    var shouldRun = (0,react.useRef)(false);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref4 = (0,react.useState)(null), docId = ref4[0], setDocId = ref4[1];
    var ref5 = (0,react.useState)(0), page = ref5[0], setPage = ref5[1];
    var ref6 = (0,react_intersection_observer/* useInView */.YD)(), ref7 = ref6.ref, inView = ref6.inView;
    var ref8 = (0,react.useState)(false), loading = ref8[0], setIsLoading = ref8[1];
    var ref9 = (0,react.useState)(false), isDisplayingFavourites = ref9[0], setIsDisplayingFavourites = ref9[1];
    var ref10 = (0,react.useState)(true), triggerPaginate = ref10[0], setTriggerPaginate = ref10[1];
    var ref11 = (0,react.useState)(), locationFilter = ref11[0], setLocationFilter = ref11[1];
    (0,react.useEffect)(function() {
        dispatch((0,createTabSlice/* setTab */.IE)(tabs/* default.Search */.Z.Search));
        if (!activeBrowseTab) {
            if (userType === UserType/* default.Client */.Z.Client) {
                dispatch((0,createBrowsePageSlice/* setActiveTab */.r7)(BrowseType/* default.Chef */.Z.Chef));
            } else if (userType === UserType/* default.Chef */.Z.Chef) {
                dispatch((0,createBrowsePageSlice/* setActiveTab */.r7)(BrowseType/* default.Gig */.Z.Gig));
            } else {
                dispatch((0,createBrowsePageSlice/* setActiveTab */.r7)(BrowseType/* default.Chef */.Z.Chef));
            }
        }
    }, []);
    (0,react.useEffect)(function() {
        if (shouldRun.current) {
            setIsLoading(true);
            setDocId(null);
            setPage(0);
            setGigsData([]);
            setChefData([]);
            switch(activeBrowseTab){
                case BrowseType/* default.Gig */.Z.Gig:
                    fetchGigs(0, null);
                    break;
                case BrowseType/* default.Chef */.Z.Chef:
                    fetchChefs(0, null);
                    break;
            }
        }
        shouldRun.current = true;
    }, [
        activeBrowseTab,
        isDisplayingFavourites,
        locationFilter
    ]);
    (0,react.useEffect)(function() {
        setIsLoading(true);
        switch(activeBrowseTab){
            case BrowseType/* default.Gig */.Z.Gig:
                fetchGigs(page, docId);
                break;
            case BrowseType/* default.Chef */.Z.Chef:
                fetchChefs(page, docId);
                break;
        }
    }, [
        triggerPaginate
    ]);
    function fetchGigs(page, docId) {
        return _fetchGigs.apply(this, arguments);
    }
    function _fetchGigs() {
        _fetchGigs = (0,_async_to_generator/* default */.Z)(function(page, docId) {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,gig/* getGigs */.si)({
                                limit: General/* GIG_PAGINATION_LIMIT */._Y,
                                page: page
                            }, docId, isDisplayingFavourites && userUid ? userUid : null, userUid || null)
                        ];
                    case 1:
                        response = _state.sent() || [];
                        setIsLoading(false);
                        if (response !== undefined) {
                            setGigsData(function(prevData) {
                                return prevData.concat(response);
                            });
                            setHasMoreData(response.length !== 0);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchGigs.apply(this, arguments);
    }
    function fetchChefs(page, docId) {
        return _fetchChefs.apply(this, arguments);
    }
    function _fetchChefs() {
        _fetchChefs = (0,_async_to_generator/* default */.Z)(function(page, docId) {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,user/* getChefs */.p4)({
                                limit: General/* CHEF_PAGINATION_LIMIT */.r4,
                                page: page
                            }, docId, isDisplayingFavourites && userUid ? userUid : null, locationFilter)
                        ];
                    case 1:
                        response = _state.sent() || [];
                        setIsLoading(false);
                        if (response !== undefined) {
                            setChefData(function(prevData) {
                                return prevData.concat(response);
                            });
                            setHasMoreData(response.length !== 0);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchChefs.apply(this, arguments);
    }
    // Infinite Scroll
    (0,react.useEffect)(function() {
        if (inView && hasMoreData && !loading) {
            switch(activeBrowseTab){
                case BrowseType/* default.Gig */.Z.Gig:
                    if (gigsData.length > 0) {
                        setDocId(gigsData[gigsData.length - 1].gigId || null);
                    }
                    break;
                case BrowseType/* default.Chef */.Z.Chef:
                    if (chefData.length > 0) {
                        setDocId(chefData[chefData.length - 1].uid || null);
                    }
                    break;
            }
            setPage(function(prevPage) {
                return prevPage + 1;
            });
            setTriggerPaginate(function(latestState) {
                return !latestState;
            });
        }
    }, [
        inView
    ]);
    var displayBrowseTabs = function() {
        if (activeBrowseTab === BrowseType/* default.Gig */.Z.Gig) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(browse_BrowseGigsTab, {
                gigs: gigsData,
                isLoading: loading
            });
        } else if (activeBrowseTab === BrowseType/* default.Chef */.Z.Chef) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(browse_BrowseChefsTab, {
                chefs: chefData,
                isLoading: loading
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "More Pleaze: Private chef experiences where gourmet meets health"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "More Pleaze: Private chef experiences where gourmet meets health"
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "More Pleaze: Private chef experiences where gourmet meets wellness, approachable meets luxury, and all are welcome. Book your chef today!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "Private Chef Services, Personal Chef at Home, In-Home Dining Experience, Custom Menu Creation, Gourmet Meal Preparation, Exclusive Dinner Parties, Luxury Catering, Bespoke Culinary Services, Fine Dining in Your Home, Chef for Special Occasions, Personalized Cooking Classes, Farm-to-Table Chef, Healthy Meal Planning, Seasonal and Local Cuisine, Dietary-Specific Chef (e.g., Vegan, Gluten-Free), Intimate Event Catering, Culinary Experience Designer, Private Brunch Services, Corporate Event Chef, Artisanal Ingredients "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "morepleaze.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "index, follow"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "More Pleaze: Private chef experiences where gourmet meets health"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "More Pleaze: Private chef experiences where gourmet meets wellness, approachable meets luxury, and all are welcome. Book your chef today!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://morepleaze.com"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(browse_TopBar, {
                        setIsDisplayingFavourites: setIsDisplayingFavourites,
                        browseType: activeBrowseTab
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            py: {
                                xs: "82px",
                                md: "0px"
                            }
                        },
                        children: [
                            displayBrowseTabs(),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "10px 0"
                                },
                                ref: ref7,
                                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        display: "grid",
                                        placeItems: "center",
                                        height: "100%",
                                        width: "100%",
                                        background: "transparent"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                        color: "primary"
                                    })
                                }) : null
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
Browse.getLayout = function getLayout(component) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerLayout/* default */.Z, {
        children: component
    });
};
var __N_SSG = true;
/* harmony default export */ var browse = (Browse);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4838,8809,9066,6886,2891,6570,9012,9774,2888,179], function() { return __webpack_exec__(78791); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);